export const CART_LINK = '[CART_LINK]'

export const PRICES = {
  today: 15990,
  real: 81600,
  guide: 39900,
  totalValue: 81600,
}

/** Tácticas de percepción de precio */
export const priceFraming = {
  comparisonShort: 'Menos que un delivery de sushi para dos',
  comparisonLong: 'Menos que un delivery de sushi para dos, o que 2 cafés con amigas al mes.',
}

/** SECCIÓN: "Esto es exactamente lo que te preocupa..." */
export const painPoints = [
  'Estás cansada de empezar proyectos y abandonarlos a la semana',
  'Buscás terminar lo que empezás, pero te frena "no tener disciplina"',
  'Ya probaste cursos larguísimos que nunca terminaste',
  'Te da miedo "tirar la plata" en otro método que no vas a sostener',
  'Pensás que no podés usar el arte porque "no sabés dibujar"',
]

export const disqualifier =
  'Este método NO es para vos si buscás una solución mágica sin dedicarle 8 minutos por día.'

/** SECCIÓN: escenarios donde el método hace la diferencia */
export const scenarios = [
  {
    title: 'Sabés exactamente qué hacer, pero no lo hacés',
    image:
      'https://cdn.magicpatterns.com/uploads/26pXBfhcXVYvF4AjTjYeie/situacion_1.png',
  },
  {
    title: 'Esperás sentirte motivada para recién ahí empezar',
    image:
      'https://cdn.magicpatterns.com/uploads/5CPwUuFntTxHTUBvjXTWTL/situacion_2.png',
  },
  {
    title: 'Hay algo que te frena y no sabés bien qué es',
    image:
      'https://cdn.magicpatterns.com/uploads/9gbB2hKcj6qfXRMVTzeTM9/situacion_3.png',
  },
]

/** SECCIÓN: "Este método es para quién..." */
export const forWho = [
  {
    emoji: '🎯',
    text: 'Quien quiere un paso a paso, sin adivinar ni inventar nada',
  },
  {
    emoji: '⏱️',
    text: 'Quien tiene 8 minutos por día y no una tarde libre',
  },
  {
    emoji: '💰',
    text: 'Quien no quiere gastar en cursos largos que no termina',
  },
  {
    emoji: '🎨',
    text: 'Quien nunca dibujó nada: no hace falta saber dibujar',
  },
  {
    emoji: '🧩',
    text: 'Quien carga bloqueo emocional, procrastinación, autosabotaje o miedo a mostrar lo que hace',
  },
]

/** Chips de la caja de oferta */
export const offerChips = [
  '✓ Guion exacto de tapping EFT',
  '✓ Consignas de arte guiado',
  '✓ 4 tipos de bloqueo cubiertos',
  '✓ Un solo PDF, un solo pago',
]

export const productPillars = [
  {
    emoji: '🎯',
    title: 'Paso a paso, sin adivinar',
    description:
      'Guion exacto de tapping EFT + consignas de arte guiado. Seguís los pasos, no tenés que inventar nada.',
  },
  {
    emoji: '💰',
    title: 'Sin gastar en cursos que no terminás',
    description:
      'Un solo PDF, un solo pago, resultados desde el primer día. Nada de suscripciones ni materiales caros.',
  },
  {
    emoji: '🎨',
    title: '4 tipos de bloqueo cubiertos, apta para TODAS',
    description:
      'No hace falta saber dibujar. Sirve para bloqueo emocional, procrastinación, autosabotaje y miedo a mostrar lo que hacés.',
  },
]

export const bonuses = [
  {
    label: '🎁 BONO #1',
    title: 'Tarjeta Rápida DesbloqueARTE',
    description:
      'Tu recordatorio de bolsillo del método SOLTÁ · CREÁ · ACTUÁ para usar en el momento exacto en que aparece el bloqueo.',
    bullets: [
      'El método completo en una sola tarjeta',
      'Para tener a mano en el escritorio o el celu',
      'Se usa en el momento en que te frenás',
    ],
    value: 11900,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2b1b6c0e-f147-4dd9-94a2-25cd5803f513.jpg',
  },
  {
    label: '🎁 BONO #2',
    title: 'Plantilla Reutilizable Soltá-Creá-Actuá',
    description:
      'Imprimila o usala desde el celu todas las veces que quieras, para cualquier proyecto que tengas pausado.',
    bullets: [
      'Sirve para cualquier proyecto frenado',
      'Se usa desde el celu o impresa',
      'Reutilizable, sin límite de veces',
    ],
    value: 13900,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f1a3d8a0-a48f-427d-9e9c-375e8f05dfc3.jpg',
  },
  {
    label: '🎁 BONO #3',
    title: 'Mi Segunda Temporada (E-book)',
    description:
      'El e-book completo para seguir sosteniendo el hábito una vez que terminaste lo primero que tenías frenado.',
    bullets: [
      'Para sostener el hábito después del primer logro',
      'Lectura corta, aplicable desde el día uno',
      'Acceso digital de por vida',
    ],
    value: 15900,
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ab28dd1d-94e4-4aaf-8ed9-19772564bbbd.jpg',
  },
]

export const valueStack = [
  { label: 'Guía DesbloqueARTE completa', value: PRICES.guide },
  { label: 'Bono 1: Tarjeta Rápida', value: 11900 },
  { label: 'Bono 2: Plantilla Reutilizable', value: 13900 },
  { label: 'Bono 3: Mi Segunda Temporada', value: 15900 },
]

export const testimonials = [
  {
    name: 'Valentina',
    age: '34 años',
    quote:
      'Hice el ejercicio un domingo a la mañana y terminé algo que tenía pausado hace 3 meses. En 8 minutos, en serio.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/9560e30e-7049-4532-95da-f3ee0a453d3e.jpg',
  },
  {
    name: 'Camila',
    age: '29 años',
    quote: 'Nunca dibujé nada en mi vida. Las consignas te llevan de la mano igual.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7147aa55-42fa-45c6-bc6e-ae6aad297048.jpg',
  },
  {
    name: 'Rocío',
    age: '41 años',
    quote: "Dejé de sentir que 'me falta disciplina'. Era otra cosa, y esto me ayudó a verlo.",
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e6e6c5d5-4cdc-46a7-b383-e53ba76418e3.jpg',
  },
]

export const faqs = [
  {
    question: '¿Cómo me llega?',
    answer:
      'Acceso digital instantáneo por mail apenas completás la compra. Se lee y se hace desde el celu o impreso.',
  },
  {
    question: '¿Sirve si nunca dibujé nada?',
    answer: 'Sí. Las consignas están armadas para cualquiera, sin habilidad artística previa.',
  },
  {
    question: '¿Es un pago único?',
    answer: 'Sí. $19.990, un solo pago, acceso de por vida. Sin suscripciones.',
  },
  {
    question: '¿Y si no me gusta?',
    answer:
      'Tenés 7 días para probarlo. Si en esos 7 días no sentiste que algo se soltó, me escribís y te devuelvo el 100% de tu dinero. Sin explicaciones ni vueltas.',
  },
]

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/uploads/pBjDdXVeonb98HeGLeTGqa/ChatGPT_Image_11_ago_2026,_13_25_34.png',
  heroVideo: 'https://cdn.magicpatterns.com/uploads/p97FctwDcCKi3TbbLbEWaU/c84bccce-5a1e-4e5a-a254-a138691d73ae-1786736221675.mp4',
  mockup:
    'https://cdn.magicpatterns.com/uploads/rnFcE8zCtUNxRnRbbin2Gu/ChatGPT_Image_12_ago_2026,_21_31_57.png',
}
